// extracted by mini-css-extract-plugin
module.exports = {"root":"DocListPermit_root__3wGAV","attachment":"DocListPermit_attachment__3ImLk"};